module.exports = __webpack_public_path__ + "static/media/school.a478d38e.jpg";